import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSmsTemplateRecipientList = async (): Promise<string[]> => {
  const response = await queryExecute({
    query: graphql(`
      query GetSmsTemplateRecipientList {
        getSmsTemplateRecipientList
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.getSmsTemplateRecipientList;
};
